import SmartModalHero from './SmartModalHero'

export type { SmartModalHeroProps } from './SmartModalHero'

export default SmartModalHero
